<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bmSq1x/tc-custom/9781426890208.jpg?1743947449947" alt="This image is the cover for the book Love & Scandal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love & Scandal
      </h1>
      <p class="bookDescription body article font2">
        <b>Nothing sells like love &amp; scandal...</b><br/><br/>Collette Jardiniere writes of passion and seduction but has experienced neither. Her pseudonymous novel, <i>The Last Days of a Rake,</i> has shocked Victorian society <i>and</i> become a runaway bestseller. Infamous roué Charles Jameson is "revealed" as the author, and Collette is outraged when the cad does little to curtail the gossip.<br/><br/>Intrigued by the book the tabloids claim is his thinly veiled autobiography, Jameson tries to find the <i>real</i> author. Returning to London after an unsuccessful hunt, he is pleasantly distracted by a plain country miss reading the wicked book.<br/><br/>Collette is dismayed when she learns the identity of the devastatingly handsome man who kissed her senseless. And Jameson cannot believe that <i>she</i> wrote <i>The Last Days of a Rake.</i> As Collette tries to convince him of the truth, their mutual attraction reaches a fever pitch, and soon they find themselves in a real-life scandal!<br/><br/>93,000 words
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donna Lea Simpson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Carina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e77b008